import { useState, useEffect, useRef } from "react";
import "./navbar.css";
import { Fade } from "react-reveal";
import { usePortfolioData } from "../../hooks/usePortfolioData";

const Navbar = () => {
  const { data } = usePortfolioData();
  const cvUrl = data?.personal?.cvUrl || "/assets/TOLANI_FAGBENJA_CV.pdf";
  const [navClass, setNavClass] = useState("navbar-container");
  const [currentActive, setCurrentActive] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [hamState, setHamState] = useState(false);

  const [isNavVisible, setIsNavVisible] = useState(true);
  const [prevScrollPos, setPrevScrollPos] = useState(0);

  const elementRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.pageYOffset;

      // Check if scrolling down and past a threshold (e.g., 50 pixels)
      if (prevScrollPos > currentScrollPos || currentScrollPos < 50) {
        setIsNavVisible(true);
      } else {
        setIsNavVisible(false);
      }

      setPrevScrollPos(currentScrollPos);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [prevScrollPos]);

  const removeClass = () => {
    if (elementRef.current) {
      elementRef.current.classList.remove("blurred");
      elementRef.current.classList.add("transparent");
    }
  };
  const addClass = () => {
    const scrollY = window.scrollY;

    if (elementRef.current && scrollY > 15) {
      elementRef.current.classList.remove("transparent");
      elementRef.current.classList.add("blurred");
    }
  };

  const handleClick = () => {
    setIsOpen(!isOpen);
    setHamState(!hamState);
    document.body.style.overflowY = hamState ? "scroll" : "hidden";

    // if (!hamState) {
    //   removeClass();
    // } else {
    //   addClass();
    // }
  };

  useEffect(() => {
    // if (!hamState) {
    //   setNavClass(navClass.replace("blurred", "transparent"));
    // } else {
    //   setNavClass(navClass.replace("transparent", "blurred"));
    // }
  }, [hamState]);

  const about = () => {
    setCurrentActive("about");
  };
  const exp = () => {
    setCurrentActive("exp");
  };

  const work = () => {
    setCurrentActive("work");
  };
  const contact = () => {
    setCurrentActive("contact");
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;

      if (scrollY > 15) {
        setNavClass("navbar-container blurred");
      } else {
        setNavClass("navbar-container");
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const removeham = () => {
    setIsOpen(!isOpen);
    setHamState(!hamState);
    document.body.style.overflowY = hamState ? "scroll" : "hidden";

    if (!hamState) {
      removeClass();
    } else {
      addClass();
    }
  };

  const divRef = useRef(null);

  useEffect(() => {
    const divElement = divRef.current;
    if (divElement) {
      const { top, left, right, bottom } = divElement.getBoundingClientRect();
      console.log("Coordinates:", { top, left, right, bottom });
    }
  }, []);

  return (
    <div className="overlord-nav">
      {hamState && <div className="glass-overlay" onClick={removeham}></div>}
      <div
        ref={elementRef}
        className={`${navClass} ${isNavVisible ? "visible" : "hidden"} ${
          isOpen ? "menu-open" : ""
        }`}
      >
        <div className="navbar-logo">
          <img src="./assets/accent-logo.svg" alt="" ref={divRef} />
        </div>

        <div className="navbar-links">
          <Fade delay={150}>
            <a
              className="navlink"
              href="#about"
              onClick={about}
              style={{
                color: currentActive === "about" ? "var(--accent-color)" : "",
              }}
            >
              <span className="navnum">01.</span>About
            </a>
          </Fade>
          <Fade delay={200}>
            <a
              className="navlink"
              href="#experience"
              onClick={exp}
              style={{
                color: currentActive === "exp" ? "var(--accent-color)" : "",
              }}
            >
              <span className="navnum">02.</span>Experience
            </a>
          </Fade>
          <Fade delay={250}>
            <a
              className="navlink"
              href="#work"
              onClick={work}
              style={{
                color: currentActive === "work" ? "var(--accent-color)" : "",
              }}
            >
              <span className="navnum">03.</span>Work
            </a>
          </Fade>
          <Fade delay={300}>
            <a
              className="navlink"
              href="#contact"
              onClick={contact}
              style={{
                color: currentActive === "contact" ? "var(--accent-color)" : "",
              }}
            >
              <span className="navnum">04.</span>Contact
            </a>
          </Fade>
          <Fade delay={350}>
            <a
              className="navlink"
              target="_blank"
              rel="noopener noreferrer"
              href={cvUrl}
            >
              Resume
            </a>
          </Fade>
        </div>
        {/* <Fade delay={150}> */}
        <div
          className={`hamburger-icon ${isOpen ? "open" : ""}`}
          onClick={handleClick}
        >
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </div>
        {/* </Fade> */}

        {/* <div
          className={
            hamState
              ? "open-container ham-container"
              : "closed-container ham-container"
          }
        >
          <div className="ham-links">
            <a
              className="navlink"
              href="#about"
              onClick={() => {
                about();
                removeham();
              }}
              style={{
                color: currentActive === "about" ? "var(--accent-color)" : "",
              }}
            >
              <span className="navnum">01.</span>
              <p>About</p>
            </a>

            <a
              className="navlink"
              href="#experience"
              onClick={() => {
                exp();
                removeham();
              }}
              style={{
                color: currentActive === "exp" ? "var(--accent-color)" : "",
              }}
            >
              <span className="navnum">02.</span>Experience
            </a>

            <a
              className="navlink"
              href="#work"
              onClick={() => {
                work();
                removeham();
              }}
              style={{
                color: currentActive === "work" ? "var(--accent-color)" : "",
              }}
            >
              <span className="navnum">03.</span>Work
            </a>

            <a
              className="navlink"
              href="#contact"
              onClick={() => {
                contact();
                removeham();
              }}
              style={{
                color: currentActive === "contact" ? "var(--accent-color)" : "",
              }}
            >
              <span className="navnum">04.</span>Contact
            </a>

            <a
              className="navlink"
              href="/assets/TOLANI FAGBENJA CV.pdf"
              target="_blank"
              rel="noopener noreferrer"
              href={cvUrl}
            >
              Resume
            </a>
          </div>
        </div> */}
      </div>

      <div
        className={`overlay ${isOpen ? "active" : ""}`}
        onClick={handleClick}
      ></div>
      <div className={`mobile-menu ${isOpen ? "active" : ""}`}>
        <a
          href="#about"
          className="navlink"
          onClick={() => {
            handleClick();
            about();
          }}
        >
          <span className="navnum">01.</span>About
        </a>
        <a
          href="#experience"
          className="navlink"
          onClick={() => {
            handleClick();
            exp();
          }}
        >
          <span className="navnum">02.</span>Experience
        </a>
        <a
          href="#work"
          className="navlink"
          onClick={() => {
            handleClick();
            work();
          }}
        >
          <span className="navnum">03.</span>Work
        </a>
        <a
          href="#contact"
          className="navlink"
          onClick={() => {
            handleClick();
            contact();
          }}
        >
          <span className="navnum">04.</span>Contact
        </a>
        <a
          href={cvUrl}
          className="navlink"
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleClick}
        >
          Resume
        </a>
      </div>
    </div>
  );
};

export default Navbar;
